// extracted by mini-css-extract-plugin
export var cardIcon = "_ae-5";
export var cardIconUnframed = "_ae-9";
export var checkboxCard = "_ae-0";
export var checkboxCardSelected = "_ae-4";
export var disabled = "_ae-2";
export var interactive = "_ae-1";
export var outerBorder = "_ae-3";
export var spacerMedium = "_ae-8";
export var spacerSmall = "_ae-7";
export var spacerXsmall = "_ae-6";